import React from "react";
import { Button, Icon, Form, Input } from "semantic-ui-react";

export default function MDL_SYNC_MISSING_ORDER({
  orderNumber,
  setOrderNumber,
  onCancel,
  onSubmit,
}) {
  return (
    <>
      {/* Header */}
      <div className="modal-header">
        <div className="modal-header-title">Sync Missing Orders</div>

        <div className="modal-header-close" onClick={onCancel}>
          <Icon name="times circle outline" />
        </div>
      </div>

      {/* Content */}
      <div className="modal-content">
        <Form>
          <Form.Field required>
            <label>Order Number</label>

            <Input
              placeholder="Enter Missing Order Number"
              value={orderNumber}
              onChange={(e) => setOrderNumber(e.target.value.trim())}
            />
          </Form.Field>
        </Form>
      </div>

      {/* Footer */}
      <div className="modal-footer">
        <Button color="red" onClick={onCancel}>
          Cancel
        </Button>

        <Button
          color="green"
          onClick={() => {
            onCancel();
            setOrderNumber("");
            onSubmit();
          }}
          disabled={!orderNumber}
        >
          Sync
        </Button>
      </div>
    </>
  );
}
